const TURKISH_CHAR_MAP: Record<string, string> = {
  ç: 'c',
  ğ: 'g',
  ı: 'i',
  ö: 'o',
  ş: 's',
  ü: 'u',
};

/** Maps legacy API slugs to normalized Turkish route slugs. */
const LEGACY_SLUG_ALIASES: Record<string, string> = {
  'terms-of-service': 'kullanici-sozlesmesi',
  'privacy-policy': 'gizlilik-politikasi',
  'listing-agreement': 'ilan-sozlesmesi',
  'cookie-policy': 'cerez-politikasi',
  'gizlilik-sozlesmesi': 'gizlilik-politikasi',
};

/**
 * Normalizes a policy name or slug to a URL route segment
 * (e.g. "Çerez Politikası" → "cerez-politikasi").
 */
export function normalizePolicyRouteSlug(value?: string | null): string {
  if (!value?.trim()) return '';

  const trimmed = value.trim();
  const legacy = LEGACY_SLUG_ALIASES[trimmed.toLowerCase()];
  if (legacy) return legacy;

  const lower = trimmed.toLocaleLowerCase('tr-TR');
  let slug = '';

  for (const ch of lower) {
    if (TURKISH_CHAR_MAP[ch]) {
      slug += TURKISH_CHAR_MAP[ch];
      continue;
    }
    if (/[a-z0-9]/.test(ch)) {
      slug += ch;
      continue;
    }
    if (ch === ' ' || ch === '_' || ch === '-') {
      slug += '-';
    }
  }

  return slug.replace(/-+/g, '-').replace(/^-|-$/g, '');
}

/** Builds the frontend path for a policy footer link. */
export function policyRoutePath(slug?: string | null, name?: string | null): string {
  const routeSlug = normalizePolicyRouteSlug(slug) || normalizePolicyRouteSlug(name);
  return routeSlug ? `/${routeSlug}` : '/';
}
